const isImageExtension = function(fileName) {
    return fileName?fileName.match(/.(jpg|jpeg|png|gif)$/i):false
}

export {isImageExtension}